import { LOCALIZATION_GEO_MISMATCH } from 'snippets/navigation/localization-modal'

class LocalizationForm extends HTMLElement {
  elements: {
    input: HTMLInputElement | null
    search: HTMLInputElement | null
    list: HTMLElement | null
    modalMessage: HTMLElement | null
  }

  selectors = {
    name: 'data-name',
    value: 'data-value'
  }

  constructor() {
    super()
    this.elements = this.fetchElements()
  }

  connectedCallback() {
    this.elements = this.fetchElements()
    this.addEventListeners()
  }

  disconnectedCallback() {
    document.removeEventListener(LOCALIZATION_GEO_MISMATCH, this.showGeoWarning)
  }

  fetchElements() {
    return {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]') as HTMLInputElement | null,
      search: this.querySelector('#CountrySearch') as HTMLInputElement | null,
      list: this.querySelector('#CountryList') as HTMLElement | null,
      modalMessage: document.querySelector('#localization-modal-message') as HTMLElement | null
    }
  }

  addEventListeners() {
    this.elements.search?.addEventListener('input', this.onSearchInput.bind(this))
    this.querySelectorAll('a[data-value]').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    )
    document.addEventListener(LOCALIZATION_GEO_MISMATCH, this.showGeoWarning)
  }

  showGeoWarning = () => {
    this.elements.modalMessage?.classList.remove('hidden')
  }

  onSearchInput(event: Event) {
    event.preventDefault()
    const currentTarget = event.currentTarget as HTMLInputElement
    const value = currentTarget?.value?.toLowerCase()
    this.elements?.list?.querySelectorAll('a').forEach((item) => {
      const name = item.getAttribute(this.selectors.name)?.toLowerCase()
      const itemValue = item.getAttribute(this.selectors.value)?.toLowerCase()
      const wrappingListItem = item.closest('li')
      if (!wrappingListItem) return
      if (name?.includes(value) || itemValue?.includes(value)) wrappingListItem.style.display = 'block'
      else wrappingListItem.style.display = 'none'
    })
  }

  onItemClick(event: Event) {
    event.preventDefault()
    const form = this.querySelector('form')
    const target = event.target as HTMLElement
    const dataElement = target.closest('[data-value]') as HTMLElement | null

    if (!this.elements.input || !dataElement?.dataset.value) return
    this.elements.input.value = dataElement.dataset.value
    if (form) form.submit()
  }
}

customElements.define('localization-form', LocalizationForm)
